module.exports = __webpack_public_path__ + "img/loader.3d210c11.svg";